import {
  BraidsImage,
  EyelashesImage,
  HaircutImage,
  KidsImage,
  LocsImage,
  MensHaircutImage,
  NailsImage,
  NaturalHairImage,
  SilkPressImage,
  WeavesImage,
  UpdatedMakeupImage,
  EyebrowsImage,
  PedicureImage,
  WaxImage,
  WigsImage,
} from './Constants';

import { ISearchTile } from '../SearchTile/SearchTile.types';

export const tiles: ISearchTile[] = [
  {
    source: BraidsImage,
    text: 'Braids',
    searchParams: { q: 'braids' },
  },
  {
    source: NaturalHairImage,
    text: 'Natural Hair',
    searchParams: { q: 'natural hair' },
  },
  {
    source: HaircutImage,
    text: 'Haircut',
    searchParams: { q: 'haircut' },
  },
  {
    source: MensHaircutImage,
    text: 'Men\'s Haircut',
    searchParams: { q: 'mens haircut' },
  },
  {
    source: LocsImage,
    text: 'Locs',
    searchParams: { q: 'locs' },
  },
  {
    source: SilkPressImage,
    text: 'Silk Press',
    searchParams: { q: 'silk press' },
  },
  {
    source: WeavesImage,
    text: 'Weaves',
    searchParams: { q: 'weaves' },
  },
  {
    source: EyelashesImage,
    text: 'Eyelashes',
    searchParams: { q: 'eyelash-extensions' },
  },
  {
    source: NailsImage,
    text: 'Nails',
    searchParams: { q: 'acrylic-nails' },
  },
];

const kidsTile: ISearchTile = {
  source: KidsImage,
  text: 'Kids',
  searchParams: { q: 'kids' },
};

export const tilesDesktopHomePage: ISearchTile[] = [
  ...tiles,
  kidsTile,
];

export const tilesDesktopMetroPage: ISearchTile[] = [
  ...tiles,
  kidsTile,
  {
    source: WigsImage,
    text: 'Wigs',
    searchParams: { q: 'wig' },
  },
  {
    source: UpdatedMakeupImage,
    text: 'Makeup',
    searchParams: { q: 'makeup-artist' },
  },
  {
    source: EyebrowsImage,
    text: 'Eyebrows',
    searchParams: { q: 'eyebrow-threading' },
  },
  {
    source: PedicureImage,
    text: 'Pedicure',
    searchParams: { q: 'pedicure' },
  },
  {
    source: WaxImage,
    text: 'Wax',
    searchParams: { q: 'waxing' },
  },
];

export const tilesMobileMetroPage: ISearchTile[] = [
  ...tiles,
  {
    source: WigsImage,
    text: 'Wigs',
    searchParams: { q: 'wig' },
  },
  {
    source: UpdatedMakeupImage,
    text: 'Makeup',
    searchParams: { q: 'makeup-artist' },
  },
  {
    source: EyebrowsImage,
    text: 'Eyebrows',
    searchParams: { q: 'eyebrow-threading' },
  },
];
